import { FETCH_ARTWORKS as fetchArtworks } from "../../../graphql/query/Artwork";
import { FETCH_COMPANIES as fetchCompanies } from "../../../graphql/query/Company";
import { FETCH_MAILING_LISTS } from "../../../graphql/query/MailingList";

const tableProps = {
  artwork: {
    dataKey: "artworks",
    headers: [
      { label: "ID", name: "id", type: "label" },
      { label: "Title", name: "title", type: "label" },
      { label: "Description", name: "description", type: "label" },
    ],
    inputs: [
      { label: "Title", name: "title", type: "text", view: "partial" },
      { label: "Year", name: "year", type: "text", view: "partial" },
      { label: "From", name: "from", type: "date", view: "partial" },
      { label: "To", name: "to", type: "date", view: "partial" },
    ],
    FETCH_QUERY: fetchArtworks(),
  },
  company: {
    dataKey: "companies",
    headers: [
      { label: "ID", name: "id", type: "label" },
      { label: "Name", name: "name", type: "label" },
      { label: "Code", name: "code", type: "label" },
    ],
    inputs: [
      { label: "Name", name: "name", type: "text", view: "partial" },
      { label: "From", name: "from", type: "date", view: "partial" },
      { label: "To", name: "to", type: "date", view: "partial" },
    ],
    FETCH_QUERY: fetchCompanies(),
  },
  mailing_list: {
    dataKey: "mailingLists",
    headers: [
      { label: "ID", name: "id", type: "label" },
      { label: "Description", name: "description", type: "label" },
    ],
    inputs: [
      { label: "From", name: "from", type: "date", view: "partial" },
      { label: "To", name: "to", type: "date", view: "partial" },
    ],
    FETCH_QUERY: FETCH_MAILING_LISTS,
  },
};

const getTableProps = model => {
  return tableProps?.[model] || null;
};

export { getTableProps };
